import { useState } from "react";
import { useEffect, useRef } from "react";
import * as ideWrapper from "../ide-wrapper/index";
import classes from './IdeRunner.module.css'
const IdeRunner = ({ projectData }) => {

    const [load, setLoad] = useState();
    useEffect(() => {
        if (projectData) {
            setLoad(true)
            // ideWrapper.load(`${window.config.blobUrl}/${projectData.fileUrl}`, iframeRef.current, "http://localhost:1337/public/", projectData.ideConfig, projectData.ideLang, projectData.share, LoadEndCB)
            ideWrapper.load(`${projectData.fileUrl}`, iframeRef.current, projectData.ideUrl, projectData.ideConfig, projectData.ideLang ,projectData.ideId,projectData.share, LoadEndCB)
        }
    }, [projectData])

    const iframeRef = useRef();
    const LoadEndCB = (data) => {
        console.log("LoadEndCB");
        setLoad(false)
        if(data.error)
        {
            alert("אירעה תקלה בטעינת הפרויקט")
        }

    }
    return (
        <div className={classes.IdeRunner}>
            {load &&<div className={classes.LoaderWrap}> <div className={classes.Loader}></div></div>}
            <iframe className={classes.RunnerIframe} frameBorder={0} ref={iframeRef}></iframe>
        </div>
    )
}
export default IdeRunner